import { combineReducers } from 'redux';
// import shelfReducer from './shelf/reducer';
import cartReducer from './cart/reducer';
import totalReducer from './total/reducer';
import searchReducer from './search/reducer';
import sortReducer from './sort/reducer';
import apiReducer from './api/reducer';

export default combineReducers({
  // shelf: shelfReducer,
  cart: cartReducer,
  total: totalReducer,
  search: searchReducer,
  sort: sortReducer,
  api:apiReducer
});
